module.exports = __webpack_public_path__ + "static/media/10_nature.2e7d405f.jpg";